import React from 'react';
import { connect } from 'react-redux';
import { KuposInput } from '../../../common';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeNineTitle from '../common/ThemeNineTitle';

const ThemeNineWorkWithUs = props => {
  const operator = props.home && props.home.operator;
  return (
    <div className="themes-theme-nine-work-with-us">
      <KuposHelmet />

      <div style={{ position: 'relative', marginTop: -20 }}>
        <HeroSection
          // height={'30vh'}
          heroImage={getIcons('workWithUsBanner')}
          title={'Trabaja con nosotros '}
          description={'Home / Trabaja con nosotros '}
        />
      </div>

      <ThemeNineTitle title={'¡Únete a nuestro equipo!'} />

      <div className="new-container">
        <div className="job-details-and-email">
          {
            operator && operator.operator_name == 'thaebus' ? 
            <div>
              Buscamos personal para hacer crecer nuestra empresa.
            </div> 
            :
            <div>
            Buscamos personal en el área de contabilidad y mecánica para hacer crecer nuestra
            empresa.
          </div>

          }
          
          <div className="mail-container">
            <span>
              <img src={getIcons('contactMailBlue')} />
            </span>
            {
              operator && operator.name == 'thaebus' ? 
              <span className="bold-text">
              Si cumples con los requisitos, puedes enviarnos tu currículum a: <a href='mailto:rrhh@busesahumada.cl'>rrhh@busesahumada.cl</a>
            </span>
            : 
            <span className="bold-text">
              Puedes enviarnos tu curriculum a: <a href='mailto:postulaciones@thaebus.com'>postulaciones@thaebus.com</a>
            </span>

            }
          </div>
        </div>
        <div className="form-container">

          <div className='form-row'>
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Nombre Completo</div>
              <KuposInput
                type="text"
                placeholder="Ej. Pedro"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Teléfono</div>
              <KuposInput
                type="text"
                placeholder="+56 9 0000 0000"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>
          </div>

          <div className='form-row'>
            <div className="contact-input-item">
              <div for="email" className="contact-input-label less-bold-text ">Email</div>
              <KuposInput
                type="email"
                placeholder="ejemplo@gmail.com"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              />
            </div>
          </div>


          <div className='cv-attachment'>


            <label for="inputTag">
              <img src={getIcons('cvAttached')} />
              <span>Adjunta tu CV</span>
              <input id="inputTag" type="file" />
            </label>

            
          </div>

          <div className='form-row'>
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Comentario</div>
              <textarea
                placeholder="Opcional"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                className={'input-theme-nine'}
              >
              </textarea>
            </div>
          </div>

          <div className="contact-input-item-btn center ">
            <button
              class="btn submit-btn  bold-text"
              style={{
                background:
                  operator &&
                  operator.color_codes &&
                  operator.color_codes.button_color &&
                  operator.color_codes.button_color,
                color: 'white',
                // width: '100%',
              }}
            >
              ENVIAR
            </button>
          </div>


        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeNineWorkWithUs);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineWorkWithUs.js